import { useEffect, useState } from 'react';
import { logError } from 'src/utils/logger';
import TableQuery from 'assets/js/editor/table/table-query';

function getRowSize (tableElement, tableDimensions, index) {
  const rowElement = tableElement.querySelector(`.table-row.index-${index} .table-cell:not(.table-cell-max):not(.table-cell-min)`);
  const targetElement = rowElement || tableElement.querySelector(`.table-row.index-${index} rect`);

  return targetElement.getBBox().height / tableDimensions.height * 100;
}

function getColumnSize (tableElement, tableDimensions, index) {
  const columnElement = tableElement.querySelector(`.table-cell.index-c-${index}:not(.table-cell-max):not(.table-cell-min)`);
  const targetElement = columnElement || tableElement.querySelector(`.table-cell.index-c-${index} rect`);

  return targetElement.getBBox().width / tableDimensions.width * 100;
}

export default function useTableSelectionMap (tableElement) {
  const [selectionMap, setSelectionMap] = useState({
    table: false,
    rows: [],
    columns: []
  });

  const calculateSelectionState = (tableState) => {
    const tableDimensions = tableElement.querySelector('rect').getBBox();

    return {
      table: tableState.every(row => row.every(cell => cell === true || cell === null)),
      rows: tableState.map((row, index) => ({
        size: getRowSize(tableElement, tableDimensions, index),
        isSelected: row.every(cell => cell === true || cell === null)
      })),
      columns: tableState[0].map((_, index) => ({
        size: getColumnSize(tableElement, tableDimensions, index),
        isSelected: tableState.every(row => row[index] === true || row[index] === null)
      }))
    };
  };

  useEffect(() => {
    const handleSelectionChange = () => {
      try {
        const tableState = TableQuery.getTableState(tableElement);
        if (!tableState || !tableState.length) {
          logError('handleSelectionChange', new Error('Invalid table state'));
          return;
        }
        const newSelectionMap = calculateSelectionState(tableState);
        setSelectionMap(newSelectionMap);
      } catch (error) {
        logError('handleSelectionChange', error);
      }
    };

    INKIVE.EditorFacade.on('table.selection_changed', handleSelectionChange);

    // Initial state update
    handleSelectionChange();

    return () => {
      INKIVE.EditorFacade.off('table.selection_changed', handleSelectionChange);
    };
  }, [tableElement]);

  return selectionMap;
}
